const reducer = (state, action) => {
  return {
    ...state,
    giftCardValidationNonce: action.payload,
  };
};

export default reducer;
